import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function Register() {
  const { user, register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "operator" });
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await register(form.email, form.password, form.name, form.role);
    setBusy(false);
    if (!r.ok) toast.error(r.error);
    else { toast.success("Account creato"); nav("/"); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8" data-testid="register-page">
      <form onSubmit={submit} className="w-full max-w-md space-y-6 fade-up surface-card p-8" data-testid="register-form">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{ background: "var(--gold)" }}>
            <ShieldCheck className="w-5 h-5 text-slate-900" />
          </div>
          <div>
            <p className="label-overline">HACCP</p>
            <h2 className="font-display text-2xl font-bold tracking-tight">Crea account</h2>
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="name">Nome completo</Label>
          <Input id="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="register-name-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="register-email-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password (min. 6 caratteri)</Label>
          <Input id="password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="register-password-input" />
        </div>
        <div className="space-y-2">
          <Label>Ruolo</Label>
          <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
            <SelectTrigger data-testid="register-role-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="operator">Operatore</SelectItem>
              <SelectItem value="admin">Admin</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <Button type="submit" disabled={busy} className="w-full bg-slate-900 hover:bg-slate-800 text-white h-11" data-testid="register-submit-btn">
          {busy ? "Creazione…" : "Crea account"}
        </Button>

        <div className="text-sm text-slate-500 text-center">
          Hai già un account?{" "}
          <Link to="/login" className="font-semibold text-slate-900 underline underline-offset-4" data-testid="register-to-login-link">Accedi</Link>
        </div>
      </form>
    </div>
  );
}
